<div class="table-container">


  <div class="card border-0 rounded-3 p-2 mt-3"
    style="background: linear-gradient(to right, #f9fafb 0.1%, #d4edda 50%)">
    <div class="d-flex flex-wrap justify-content-between align-items-center m-1 p-2">
      <div>
        <button (click)="downloadExcel('Product Search')" type="button" class="btn btn-success m-1">
          Download Product Template
        </button>
        <button (click)="downloadLocationExcel('Location')" type="button" class="btn btn-success m-1">
          Download Location Template
        </button>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <p class="p-0 m-0" style="color: #6c757d">
          Click the button to download the template for uploading data.
        </p>
      </div>
    </div>
  </div>

  <!-- //Excel Upload file -->
  <div class="card border-0 rounded-3 p-2 mt-3"
    style="background: linear-gradient(to right, #f9fafb 0.1%, #d4edda 50%)">
    <div class="d-flex flex-wrap justify-content-start align-items-center m-1 p-2">
      <div class="m-1">
        <div class="mb-3">
          <label for="formFile" class="form-label">Upload product excel file</label>
          <input class="form-control" type="file" id="formFile" (change)="handleFileChange($event)" />
        </div>
      </div>
      
      <div class="m-1">
        <div class="mb-3">
          <label for="formFile" class="form-label">Upload location excel file</label>
          <input class="form-control" type="file" id="formFile" (change)="handleFileChange($event)" />
        </div>
      </div>
    </div>
    
  </div>

  <p class="fw-medium fs-5 mt-4">Product Table</p>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

    <!-- data Title Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let data; let i = index">
        {{ i + 1 }}
      </td>
    </ng-container>

    <!-- Platform Column -->
    <ng-container matColumnDef="platform">
      <th mat-header-cell *matHeaderCellDef>Platform</th>
      <td mat-cell *matCellDef="let element">{{ element.Platform }}</td>
    </ng-container>

    <!-- Platform ID Column -->
    <ng-container matColumnDef="platformId">
      <th mat-header-cell *matHeaderCellDef>Platform ID</th>
      <td mat-cell *matCellDef="let element">{{ element.PlatformId }}</td>
    </ng-container>

    <!-- WebPID Column -->
    <ng-container matColumnDef="webpid">
      <th mat-header-cell *matHeaderCellDef>WebPID</th>
      <td mat-cell *matCellDef="let element">{{ element.WebPID }}</td>
    </ng-container>

    <!-- Brand Column -->
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef>Brand</th>
      <td mat-cell *matCellDef="let element">{{ element.Brand }}</td>
    </ng-container>

    <!-- Product Type Column -->
    <ng-container matColumnDef="productType">
      <th mat-header-cell *matHeaderCellDef>Product Type</th>
      <td mat-cell *matCellDef="let element">{{ element.Type }}</td>
    </ng-container>

    <!-- Country Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>Country</th>
      <td mat-cell *matCellDef="let element">{{ element.Country }}</td>
    </ng-container>

    <tr mat-header-row class="bg-primary text-light" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row class="" style="font-size: small;" *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <p class="fw-medium fs-5 mt-4">Location Table</p>

  <app-location [country]="country" [platform]="platform" ></app-location>
</div>